import React from 'react'
import { EmpresaData } from '../utils/interfaceTickets'
import { TICKETS_TYPES } from '../utils/constantsTickets'

interface HeaderTicketsProps {
    imageRef?: React.RefObject<HTMLImageElement>
    data: any
    logoBaseProp?: string
}

const HeaderCreditTickets = ({ imageRef, data, logoBaseProp }: HeaderTicketsProps) => {
    var LOGO_TICKET = logoBaseProp ?? null
    var DATA_EMPRESA = data.empresa

    if (!LOGO_TICKET) {
        const { empresa } = data as { empresa: EmpresaData }

        DATA_EMPRESA = empresa.empresa
    }

    return (
        <div className="receipt__text__center">
            {
                LOGO_TICKET && (
                    <img
                        ref={imageRef}
                        alt="Logo Tirilla"
                        className='img__logo__tirilla'
                        src={LOGO_TICKET}
                    />
                )
            }

            <p className='receipt__text__center text__bold'>{DATA_EMPRESA.razon_social}</p>
            <p className='receipt__text__center text__bold'>{DATA_EMPRESA.alias}</p>
            <p className='receipt__text__center text__bold'>{DATA_EMPRESA.direccion}</p>
            <p className='receipt__text__center text__bold'>TEL: {DATA_EMPRESA.telefono}</p>
            <p className='receipt__text__center text__bold'>{data.tipo_venta === TICKETS_TYPES.CREDIT ? DATA_EMPRESA.correo : ''}</p>
            <p className='receipt__text__center text__bold'>NIT {DATA_EMPRESA.nit}</p>

            <div className='receipt__separator'></div>
            <table>
                <tbody>
                    <tr>
                        <td className="receipt__table__cell">TIPO REPORTE:</td>
                        <td className="receipt__table__cell__right">WEB</td>
                    </tr>
                </tbody>
            </table>

        </div>
    )
}

export default HeaderCreditTickets